import markdownit from "markdown-it"

const md = markdownit({
  linkify: true,
})

export function renderMarkdownToHtml(text?: string | null): string {
  if (!text) return ""
  return md.render(text)
}
